import React from 'react';

import { array, arrayOf, bool, element, func, object, oneOfType, string } from 'prop-types';

import { propagateData } from '@philips-emr/tws-utils';

import { Link } from '../..';

function ChangeRecord(props) {
  return (
    <Link
      className="c-finder__change-record"
      onClick={props.onClick}
      value={props.expression}
    />
  );
}

ChangeRecord.propTypes = {
  expression: string,
  onClick: func,
};

function getSingleResult(element, value) {
  return propagateData(element, value);
}

function getSingleGroupedResult(element, value) {
  return Object.keys(element).map((key) =>
    propagateData(element[key], value[key])
  )[0];
}

function getMultiResults(element, value) {
  return []
    .concat(element)
    .map((item, itemIndex) => propagateData(item, value[itemIndex]));
}

function getMultiGroupedResults(element, value) {
  const results = [];

  Object.keys(element).forEach((key) => {
    const elements = element[key];
    const values = value[key];

    for (let index = 0; index < elements.length; index++) {
      results.push(propagateData(elements[index], values[index]));
    }
  });

  return results;
}

function getResult(element, grouped, multiselect, value) {
  if (!grouped && !multiselect) {
    return getSingleResult(element, value);
  }

  if (grouped && !multiselect) {
    return getSingleGroupedResult(element, value);
  }

  if (!grouped && multiselect) {
    return getMultiResults(element, value);
  }

  if (grouped && multiselect) {
    return getMultiGroupedResults(element, value);
  }

  return null;
}

function FinderResult(props) {
  const { changeRecordExpression, element, grouped, multiselect, onChangeRecordClick, value } = props;

  return (
    <React.Fragment>
      <div className="c-finder__result">
        {getResult(element, grouped, multiselect, value)}
      </div>
      <ChangeRecord
        expression={changeRecordExpression}
        onClick={onChangeRecordClick}
      />
    </React.Fragment>
  );
}

FinderResult.propTypes = {
  changeRecordExpression: string,
  children: oneOfType([element, arrayOf(element)]),
  element: oneOfType([object, array]),
  grouped: bool,
  multiselect: bool,
  onChangeRecordClick: func,
  value: oneOfType([object, array]),
};

export default FinderResult;
